<template>
    <div class="form-value">
        <ul class="file-area input clearfix" v-if="appturnFileList.length > 0">
            <li class="file-content" style="height: 210px" v-for="(appturnFile, index) in appturnFileList">
                <swb-file-item :trackKey="index" :fileName="appturnFile.name" :fileUuid="appturnFile.fileUuid" :fileBrowseUrl="appturnFile.fileBrowseUrl" :fileDownloadUrl="appturnFile.fileBrowseUrl" :deletable="false"></swb-file-item>
                <el-input :title="appturnFile.name" :disabled="true" v-model="appturnFile.name"></el-input>
            </li>
        </ul>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import devcReqrApi from '../../api/devcReqr';
    //
    export default {
        name: 'swb-device-require-voucher-file',
        desc: '请购附件',
        props: ['voucherId'],
        data: function () {
            return {
                appturnFileList: [],
            }
        },
        created: function () {
            //
            this.getAdjustApplyFormFileList();
        },
        methods: {
            getAdjustApplyFormFileList: function () {
                let self = this;
                let postData = {
                    voucherId: self.voucherId
                };
                let theLoad = MsgBox.loading();
                devcReqrApi.getDeviceRequireFileList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        //
                        self.appturnFileList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherFile.vue